"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CommentsCollaborationConsumer_1 = __importDefault(require("Project/Comments/Collaboration/CommentsCollaborationConsumer"));
var WidgetAdderStore_1 = __importDefault(require("Project/QwilrEditor/Widgets/WidgetAdder/WidgetAdderStore"));
var Location_1 = require("@CommonFrontend/Utils/Location");
var lodash_1 = require("lodash");
var CommentService_1 = __importDefault(require("Project/Comments/CommentService"));
var BlockStore_1 = __importDefault(require("Project/Stores/BlockStore"));
var lodash_2 = __importDefault(require("lodash"));
var CommentThreadStore_1 = __importDefault(require("Project/Comments/CommentThreadStore"));
module.exports = function (block, di) {
    var wiringObject = {
        block: block,
        blockStore: new BlockStore_1.default(block, di.get("$timeout")),
        viewState: {
            currentTab: {
                name: null,
                ui: null,
            },
            activeBlock: false,
        },
        blockEvents: function () {
            var Emitter = require("events").EventEmitter;
            return new Emitter();
        },
        blockElemSelector: ".block-container[id=".concat(block.$id, "]"),
        hasWidgets: function (block) {
            return function () {
                for (var contentAreaName in block.contentAreas) {
                    if (lodash_2.default.keys(block.contentAreas[contentAreaName].widgets).length) {
                        return true;
                    }
                }
                return false;
            };
        },
        deleteBlock: require("./DeleteBlock"),
        widgetAdderStore: function (usingFeature, blockStore, projectStore) {
            return new WidgetAdderStore_1.default(usingFeature, blockStore, projectStore);
        },
        commentService: function (apiBaseUrl, project) {
            return new CommentService_1.default(apiBaseUrl, (0, Location_1.getOrigin)(), project._id, block._id);
        },
        commentThreadStore: function (activeCommentThreadStore, commentService, user, telemetry, block, rootDataStore, blockList, projectStore) {
            return new CommentThreadStore_1.default(activeCommentThreadStore, commentService, user, telemetry, block.type, rootDataStore.userDataStore.useHistoryDataStore, blockList, projectStore);
        },
    };
    if (block._id != null) {
        (0, lodash_1.assign)(wiringObject, {
            commentsCollaborationConsumer: function (pusher, commentThreadStore, project, userList, user) {
                return new CommentsCollaborationConsumer_1.default(pusher, commentThreadStore, project._id, userList, user._id, block._id);
            },
        });
    }
    return wiringObject;
};
